import { bl_fi_mst_entity_vehicle_manufacturer_RowClass } from '../../../dbschema/bl_fi_mst_entity_vehicle_manufacturer.model';
import {BaseContainerModel} from '../../base-container.model';


export class VehicleManufacturerContainerModel extends BaseContainerModel {
bl_fi_mst_entity_vehicle_manufacturer: bl_fi_mst_entity_vehicle_manufacturer_RowClass = new bl_fi_mst_entity_vehicle_manufacturer_RowClass();
}
